module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XJcPRg/Images/cover.jpg?1684514918589",
      "alt": "This image is the cover for the book Il nulla di Ben, Serie Storie di Austin"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Il nulla di Ben, Serie Storie di Austin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Serie Storie di Austin, Libro 1")])])]), _c('p', [_vm._v("Ben Walsh sta per diventare uno dei migliori avvocati di Manhattan; ha un fidanzato meraviglioso e amici nell’élite della città. La sua vita è perfetta, finché una telefonata non distrugge tutto: un incidente d’auto porta via tragicamente i suoi genitori e ora deve tornare a Austin per crescere tre fratelli adolescenti che conosce a malapena.")]), _vm._v(" "), _c('p', [_vm._v("Durante il funerale, Ben incontra Travis Atwood, il vicino di casa dalla parlata texana e dal cuore d’oro. All’inizio, il loro rapporto passa momenti di alti e bassi, tra discussioni e flirt, ma quando il peso della responsabilità comincia a gravare su Ben, si appoggia immediatamente a Travis, e la pressione modella la loro amicizia in qualcosa che somiglia molto all’amore. Ben pensa di aver trovato una soluzione per riavere, oltre alla sua vecchia vita, la sua nuova vita e Travis, ma deve rendersi conto che l’amore non è sempre facile. Riuscirà a capire che un’esperienza orribile potrebbe farlo giungere alla meta a cui era destinato?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brad Boney, Gaia Marino\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0